import anrokImage from './anrokCover.png'
import {
  Text,
  GreyGrey30,
  GreyGrey90,
  Image,
  ListItem,
  Primary13Regular,
  UnorderedList,
  Box,
  Flex
} from '@sequencehq/core-components'

export const AnrokIntegrationDetail = () => {
  return (
    <Flex flexDirection="column" gap="20px">
      <Image
        src={anrokImage}
        width="100%"
        aspectRatio={1288 / 512}
        borderRadius="8px"
        border={`1px solid ${GreyGrey30}`}
        draggable={false}
      />
      <Text {...Primary13Regular} color={GreyGrey90}>
        Connect Anrok to calculate and record sales tax on your invoices, based
        on your customer's location and tax registrations. This connector
        requires an account with Anrok.
      </Text>
      <Box {...Primary13Regular} color={GreyGrey90} lineHeight="18px">
        <UnorderedList>
          <ListItem>
            <strong>Automated tax calculations:</strong> Tax is calculated on
            every invoice
          </ListItem>
          <ListItem>
            <strong>Up-to-date rates:</strong> The correct rates are applied per
            jurisdiction
          </ListItem>
          <ListItem>
            <strong>Filing-ready records:</strong> Finalized invoices and credit
            notes are recorded automatically
          </ListItem>
          <ListItem>
            <strong>Multi-jurisdiction support:</strong> Record multiple tax
            registrations per customer
          </ListItem>
          <ListItem>
            <strong>Exempt customer handling:</strong> Handle tax-exempt
            customers automatically
          </ListItem>
        </UnorderedList>
      </Box>
    </Flex>
  )
}
